import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuthProvider } from './contexts/AuthContext';
import Login from './components/Login';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Dashboard from './components/Dashboard';
import Students from './components/Students';
import Content from './components/Content';
import Classes from './components/Classes';
import Users from './components/Users';
import Settings from './components/Settings';
import Unauthorized from './components/Unauthorized';
import './index.css';

function App() {
  const { t } = useTranslation();
  
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
          
          {/* Protected Routes */}
          <Route element={<ProtectedRoute />}>
            <Route element={<Layout />}>
              <Route path="/dashboard" element={<Dashboard />} />
              
              {/* Admin & Teacher Routes */}
              <Route element={<ProtectedRoute allowedRoles={['admin', 'teacher']} />}>
                <Route path="/students" element={<Students />} />
                <Route path="/content" element={<Content />} />
                <Route path="/classes" element={<Classes />} />
              </Route>
              
              {/* Admin, Teacher & Parent Routes */}
              <Route element={<ProtectedRoute allowedRoles={['admin', 'teacher', 'parent']} />}>
                <Route path="/reports" element={<div>{t('common.reports')}</div>} />
              </Route>
              
              {/* Admin Only Routes */}
              <Route element={<ProtectedRoute allowedRoles={['admin']} />}>
                <Route path="/settings" element={<Settings />} />
                <Route path="/users" element={<Users />} />
              </Route>
            </Route>
          </Route>
          
          {/* Default Route */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
